var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControllerIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 10,
    viewBox: "0 0 35 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2311 0.329956H4.93527C2.30155 0.329956 0.166504 2.46501 0.166504 5.09873V5.10539C0.166504 7.73911 2.30155 9.87416 4.93527 9.87416H30.2311C32.8648 9.87416 34.9998 7.73911 34.9998 5.10539V5.09873C34.9998 2.46501 32.8648 0.329956 30.2311 0.329956ZM8.65171 2.15491H4.05611C3.85747 2.15491 3.69645 2.31593 3.69645 2.51456V7.70693C3.69645 7.90556 3.85747 8.06658 4.05611 8.06658H8.65171C8.85034 8.06658 9.01136 7.90556 9.01136 7.70693V2.51456C9.01136 2.31593 8.85034 2.15491 8.65171 2.15491ZM17.4998 4.49662H19.9998V6.99662H17.4998V4.49662ZM22.8332 4.49662H20.3332V6.99662H22.8332V4.49662ZM11.8332 4.49662H14.3332V6.99662H11.8332V4.49662ZM17.1665 4.49662H14.6665V6.99662H17.1665V4.49662ZM27.6735 4.52596H30.1735V7.02596H27.6735V4.52596Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControllerIcon);
export default __webpack_public_path__ + "static/media/controller-icon.a993d6e47ffd869de60578128226c8db.svg";
export { ForwardRef as ReactComponent };